import packageJSON from '../../package.json';

import * as LocalConfiguration from './Configuration.local';

import * as ProductionConfiguration from './Configuration.development';

import t from 'typy';

let conf;
if (process.env.NODE_ENV === 'production') {
    conf = ProductionConfiguration;
} else {
    conf = LocalConfiguration;
}

let Version = packageJSON.version;

let BackEndURL = t(conf, 'BackEndURL').safeObject ?? '/';

let CompanyName = t(conf, 'CompanyName').safeObject ?? '';
let AppTitleTemplate = t(conf, 'AppTitleTemplate').safeObject ?? 'BioRetis - CoreSystem';
let AppTitle = t(conf, 'AppTitle').safeObject ?? AppTitleTemplate;

export {
    BackEndURL,
    Version,
    CompanyName,
    AppTitleTemplate,
    AppTitle,
}